import { ROUTES } from 'Utils/constants';
import { Link, useLocation, Outlet } from 'react-router-dom';
import IconButton from 'Components/Atoms/IconButton/IconButton';
import { useEffect, useRef, useState } from 'react';
import AppLayoutSidebarMobile from './AppLayoutSidebarMobile';
import clsx from 'clsx';
import { Slot } from 'nano-slots';
import Icon from 'Components/Atoms/Icon/Icon';
import logo from 'assets/nav-logo-open.png';
import AppLayoutHorizontalScroll from './AppLayoutHorizontalScroll';
import AppLayoutNotices from './AppLayoutNotices';

export default function AppLayoutMobile() {
    const [open, setOpen] = useState(false);
    const [hasHeader, setHasHeader] = useState(false);
    const [hasHeaderActions, setHasHeaderActions] = useState(false);

    const scrollRef = useRef(null);

    const isHeaderVisible = hasHeader || hasHeaderActions;

    const { pathname } = useLocation();

    useEffect(() => {
        setOpen(false);
    }, [pathname]);

    useEffect(() => {
        scrollRef.current?.update();
    }, [hasHeader, hasHeaderActions]);

    return (
        <>
            <div className="min-h-dvh flex flex-col">
                <header className="h-15 px-3 bg-white flex items-center justify-between shadow-2xs relative z-header">
                    <Link to={ROUTES.dashboards}>
                        <img src={logo} alt="Banktrack" height={123} width={600} className="w-[132px]" />
                    </Link>
                    <div className="flex items-center">
                        <IconButton
                            icon={<Icon name={open ? 'close' : 'menu-2'} />}
                            iconSize={24}
                            variant="ghost"
                            className={clsx({ ['pointer-events-none']: open })}
                            onClick={() => setOpen(true)}
                        />
                    </div>
                </header>

                <AppLayoutNotices />

                <div className={clsx('h-15 bg-white', !isHeaderVisible && 'hidden')}>
                    <AppLayoutHorizontalScroll ref={scrollRef}>
                        <Slot name="app-header" onChange={setHasHeader} />
                        <Slot name="app-header-actions" onChange={setHasHeaderActions} />
                    </AppLayoutHorizontalScroll>
                </div>

                <main className="grow w-full">
                    <Outlet />
                </main>
            </div>

            <AppLayoutSidebarMobile open={open} onClose={() => setOpen(false)} />
        </>
    );
}
